<template>
  <div class="personalMain">
    <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>签到</span></p>
    <div class="personal-box">
      <personalMenu></personalMenu>
      <div class="MainInfo">
        <div class="mySin-box">
          <div>
            <p>{{ msg }}</p>
            <span>{{ newDate }}</span>
          </div>
          <div v-if="signType == -1">
            <el-button round @click="signAdd">我要签到</el-button>
          </div>
        </div>
        <div class="mySin-context">
          <div v-for="item in listSign" :key='item.id' class="list-Item" v-show="listSign != ''">
            <div>
              <p>{{ item.create_time.slice(0,10) }}</p>
              <span>{{ item.create_time }}</span>

            </div>
            <p class="sinStatus">已签到</p>
          </div>
          <div v-if="listSign == ''" class="teamsNull">
              <p>亲，未找到记录~</p>
          </div>
        </div>
        <el-pagination
            :hide-on-single-page="hideOnSinglePage"
            :page-size="20"
            :pager-count="widthNew?11:5"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import personalMenu from './index.vue'
export default {
  data(){
    return{
      signType: 0,
      msg: '',
      listSign: [],
      total: 0,
      hideOnSinglePage: true,
      newDate: '',
      widthNew: false
    }
  },
  components:{
    personalMenu
  },
  methods: {
    listByUser(data){
      this.$store.dispatch('personal/listByUser',data)
      .then(res => {
        if(res.ok){
          this.total = res.data.total

            if(this.total <= 20){
                this.hideOnSinglePage = true
            }else{
                this.hideOnSinglePage = false
            }
            this.listSign = res.data.items
            this.listSign.forEach(item => {
           
            const timeDate = new Date(item.create_time)
            item.create_time = this.getDateTime(timeDate)

          });
        }
      })
    },
    getDateTime(timeDate){
      const year = timeDate.getFullYear();
      const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
      const day = timeDate.getDate().toString().padStart(2, '0');
      const hours = timeDate.getHours().toString().padStart(2, '0');
      const minutes = timeDate.getMinutes().toString().padStart(2, '0');
      const seconds = timeDate.getSeconds().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDate
    },
    handleCurrentChange(val){
        console.log(`当前页: ${val}`);
    },
    signAdd(){
      let data = {}
      this.$store.dispatch('personal/add',data)
        .then(res => {
          if(res.ok){
            this.signType = 1
            this.$notify({
              title: '成功',
              message: '签到成功',
              type: 'success'
            });
            let listSign = {
              pageNum: 1,
              pageSize: 10
            }
            this.listByUser(listSign)
          }
        })
    }
  },
  mounted(){
    var today = new Date();
    var year = today.getFullYear();//获取年份
    var month = today.getMonth() + 1;//获取月份
    var day = today.getDate();//获取日期
    console.log(year + "-" + month + "-" + day);
    this.newDate = year + "-" + month + "-" + day

    let data = {}
    this.$store.dispatch('personal/isSign',data)
      .then(res => {
        if(res.ok){ //未签到
          this.signType = -1
          this.msg = '今日未签到'
        }else{ //已签到
          this.signType = 1
          this.msg = '今日已签到'
        }
      })
    
    let listSign = {
      pageNum: 1,
      pageSize: 10
    }
    this.listByUser(listSign)
  },
  created(){
    let widthNew = document.documentElement.clientWidth
    if(widthNew > 540){
        this.widthNew = true
    }else{
        this.widthNew = false
    }
    localStorage.setItem('active','2-1')
  }
}
</script>

<style>
@import url(../../css/personal.css);
</style>

<style scoped>
.teamsNull{
    font-size: 18px;
    color: #666666;
    text-align: center;
    margin-top: 40px;
}
</style>